import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Geek at a music festival: Day 3",
  "description": "",
  "published": "2012-07-14T00:00:00.000Z",
  "redirect_from": ["/blog/geek-at-a-music-festival-day-3/swizec/4838"],
  "categories": "exit, festival, Slovenia, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-31-e1342283685189-1024x764.jpg",
        "alt": "Hercules and Love Affair have great arses and bad music",
        "title": "Hercules and Love Affair have great arses and bad music"
      }}></img></p>
    <p>{`Pain. Pain. Pain. Everything hurts.`}</p>
    <p>{`Everything.`}</p>
    <p>{`I'm supposed to do this for two more days? Are you people insane!? I'm getting too old for this shit. Don't think I was never young enough for this shit actually. My body just wasn't made for constant partying and dancing.`}</p>
    <p>{`And I know it wasn't because a moshpit `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/programmers-are-optimists/swizec/4509",
        "title": "Programmers are optimists"
      }}>{`injured my shoulder again`}</a>{` and I spent half the night dancing with just one useful arm.`}</p>
    <p>{`Despite the pain and tiredness last night will probably turn out to be the best day of EXIT. The music was perfect. The company was great. And I had enough energy to survive the whole night.`}</p>
    <p>{`Everything just ... clicked.`}</p>
    <p>{`I even realized the telephone has already been invented and can be used to call up people you know are at the festival. Met up with all the girls from Slovenia, didn't even bother finding out if I know any guys who are coming. Screw them :P`}</p>
    <p>{`There isn't much of a story there, I just wanted to mention I spent most of the night in the company of four girls.`}</p>
    <p>{`Oh and last night finally provided proof that `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/can-you-pay-one-compliment-to-one-stranger-every-day/swizec/4449",
        "title": "Can you pay one compliment to one stranger every day?"
      }}>{`paying people random compliments`}</a>{` really `}<em parentName="p">{`does`}</em>{` work. A girl ran up to me from the crowd `}<em parentName="p">{`"Heeeeey, you're from Slovenia right!? We met at bi-ko-fe!"`}</em>{` And, honestly, I didn't remember her at first. I knew I saw her at the arcades the previous night and that she seemed familiar.`}</p>
    <p>{`We discovered that she's also an exchange student at my college. But we met at bikofe, when I said her shirt looked cool. The funny thing was that she understands Slovenian, but doesn't speak it and I understand Croatian but don't speak it. So we talked in two languages for like an hour and it was just the most confusing thing ever.`}</p>
    <p>{`Ever.`}</p>
    <p>{`It's also very good to wear a hat. When we were leaving at 5am or so another girl ran up to me `}<em parentName="p">{`"Heeeey, you're that guy from the other night! I don't know if you remember me, but I found your card. Have it back at the come, wanna come over and I can give it to you?"`}</em></p>
    <p>{`Didn't go. Nature calling. Then I couldn't find her anymore even though she said she'd wait.`}</p>
    <p>{`That's a geek's life for ya, get invited to a girl's place and somehow manage not to go.`}</p>
    <p>{`PS: moshpits are `}<em parentName="p">{`fun`}</em>{`!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-4-e1342283814117-764x1024.jpg",
        "alt": "Random living statue",
        "title": "Random living statue"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-5-e1342283895969-764x1024.jpg",
        "alt": "Lollobrigida were just awesome",
        "title": "Lollobrigida were just awesome"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-6-e1342283964423-1024x764.jpg",
        "alt": "The Toy Dolls had a brilliant moshpit",
        "title": "The Toy Dolls had a brilliant moshpit"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/2012-07-14_04-38-44_67-1024x768.jpg",
        "alt": "Slovenian crew represent!",
        "title": "Slovenian crew represent!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo2-e1342284117905-1024x764.jpg",
        "alt": "So tired my hands were shaking",
        "title": "So tired my hands were shaking"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-2/swizec/4830"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100305583_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-2/swizec/4830"
        }}>{`Geek at a music festival: Day 2`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100106846_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}>{`Geek at a music festival: Day 1`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=4a5a2c3f-565f-447b-a78d-ccdd339c1ca7",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      